import { useState, useEffect } from "react"

export const Result = ({ label }) => {
  const [isChanged, setIsChanged] = useState(false)

  useEffect(() => {
    setIsChanged(true)
    const timer = setTimeout(() => {
      setIsChanged(false)
    }, 750)

    return () => clearTimeout(timer)
  }, [label])

  return (
    <div className={`results-chip${isChanged ? " flash" : ""}`}>{label}</div>
  )
}
